<template>
  <div id="app">
    <FloatingMenu />
    <FirstSection :dataHariIni="this.dataHariIni" />
    <SecondSection :dataHariIni="this.dataHariIni" />
    <ThirdSection />
    <FourthSection />
    <FifthSection />
  </div>
</template>

<script>
import FirstSection from '../components/FirstSection';
import SecondSection from '../components/SecondSection';
import ThirdSection from '../components/ThirdSection';
import FourthSection from '../components/FourthSection';
import FifthSection from '../components/FifthSection';
import FloatingMenu from '../components/FloatingMenu';

export default {
  components: {
    FirstSection,
    SecondSection,
    ThirdSection,
    FourthSection,
    FifthSection,
    FloatingMenu,
  },

  created() {
    this.getTodayData();
  },

  mounted() {
    this.setDocTitle();
  },

  methods: {
    getTodayData() {
      fetch(`/api/lastResult`).then(response => {
        if (response.ok) {
          response.json().then(res => {
            this.dataHariIni = res;
          });
        } else {
          alert('Terjadi kesalahan ketika mengambil data.');
        }
      });
    },

    setDocTitle() {
      if (localStorage.getItem('langChosen') === 'gr') {
        document.title = '집 - 부산 복권';
      } else {
        document.title = 'Home - Busan Lotteries';
      }
    },
  },

  data: function() {
    return {
      dataHariIni: {},
    };
  },
};
</script>

<style>
#app {
  width: 100vw;
}
</style>
